module.exports = __webpack_public_path__ + "img/full6-min.a32fea22.png";